/**
 * This is based heavily on the Material CDK Portal.
 * I just trimmed it down a bunch.
 */
import { ElementRef, NgZone, TemplateRef, ViewContainerRef } from '@angular/core';

import { DomOutlet } from './DomOutlet';
import { TemplateDirective } from './template.directive';

export class Template {
    private host: DomOutlet | null;

    get origin(): ElementRef {
        return this.templateDirective.template.elementRef;
    }

    get templateRef(): TemplateRef<any> {
        return this.templateDirective.template;
    }

    get viewContainerRef(): ViewContainerRef {
        return this.templateDirective.viewContainerRef;
    }

    get zone(): NgZone {
        return this.templateDirective.zone;
    }

    constructor(private templateDirective: TemplateDirective, public context?: any) {}


    attach(host: any, context: any | undefined = this.context): any {
        this.context = context;
        this.host = host;
        return host.attach(this);
    }

    detach(): void {
        this.context = undefined;

        if (this.host) {
            const host = this.host;
            this.host = null;
            host.detach();
        }
    }

    setAttachedHost(host: DomOutlet | null) {
        this.host = host;
    }
}
